export default __webpack_public_path__ + "static/media/customer_scrolled.bf5fca27.svg";